import logoInitial from "../../assets/png/Netuno_Logo_dark.png";
import { textNewPass, textlogin } from "../../locales/es-es";
import { useForm } from "../../Hooks/UseForm";
import { Link, useLocation, useRoutes } from "react-router-dom";
import { initialRecover, newPassword } from "../../propsType/RecoverPassword";
import { validationNewPassword } from "../../validations/formValidations";
import ButtonGeneric from "../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../components/Inputs/InputGeneric";
import { colors } from "../../propsType/Colors";
import { useEffect, useState } from "react";
import AuthController from "../../controllers/AuthController";
import Modal from "../../components/Modals/Modal";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";


const NewPassword = () => {
  const location = useLocation().search;
  /*const token = location.search.split("&")[1].split("=")[1];
  const email = location.search.split("=").pop();*/
  const { form, errors, setForm, handleChange, handleSubmit, handleBlur } = useForm(
    newPassword,
    validationNewPassword
  );
  const [loading, setLoading] = useState(false);
  const { recoverConfirm } = AuthController();
  const [activeModal, setActiveModal] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");
  const [showConfirPassword, setShowConfirPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const sendNewPass = async () => 
  {
    const result = handleSubmit();

    if (result === "ok") 
    {
      setLoading(true);
      let newObjet = 
      {
        token: location,
        password: form.newPass,
        passwordConfirm: form.newPassConfirm,
        
      };

      let response = await recoverConfirm(newObjet);
      if (response) 
      {
        if (response.respuesta === "0") 
        {
          setCheck(true);
          setLoading(false);
          setActiveModal(true);
          setMessage("Su contraseña fue cambiada exitosamente.");
          //setMessage(response.descripcion);
          setForm({
            ...form,
            newPass: "",
            newPassConfirm: "",
          });
        }
        else 
        {

          setCheck(false);
          setLoading(false);
          setActiveModal(true);
          setMessage(response.descripcion);
        }
      }
    }
  };


const closetModal = () => 
{
  setActiveModal(false);
  setMessage("");

}

  //Funcion para mostar el input tipo password
  const funtionShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const funtionShowConfirPassword = () => {
      setShowConfirPassword(!showConfirPassword);
  };

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

return (
  <>
    <div className="h-screen  lg:flex">
      <div className="flex-1  flex flex-col w-auto lg:w-[44%] h-screen py-4 xl:overflow-hidden justify-center  px-4 sm:px-6 md:flex-none lg:px-0 xl:px-0">
          {loading ? (
            <>
              <Spinner title={"Espere..."} />
            </>
          ) : (
            <>
        <div className="mx-auto w-full  md:max-w-sm overflow-y-auto  lg:mt-0 px-4 xl:max-w-lg xl:w-[32rem]">
          <div>
            <img className="h-12 w-auto" src={logoInitial} alt="Workflow" />
            <h2 className="mt-6 mb-2 text-3xl font-extrabold text-gray-900">
              {textNewPass.ingresar}{" "}
            </h2>
            <p className={`text-sm font-medium text-[${colors.lightBlue}]`}>
              {textNewPass.acceder}{" "}
            </p>
          </div>
          <div className="mt-8">
            <div className="mt-6">
              <div>
                <InputGeneric
                  name={"newPass"}
                  title={"Contraseña"}
                  onBlur={handleBlur}
                  value={form?.newPass}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  errorText={errors.newPass}
                  show={showPassword}
                  funtionShow={funtionShowPassword}
                  type={showPassword ? "text" : "password"}
                />
              </div>
              <div className="space-y-6 mt-5">
                <InputGeneric
                  name={"newPassConfirm"}
                  title={"Confirmar Contraseña"}
                  //type={"text"}
                  onBlur={handleBlur}
                  value={form?.newPassConfirm}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  errorText={errors.newPassConfirm}
                  show={showConfirPassword}
                  funtionShow={funtionShowConfirPassword}
                  type={showConfirPassword ? "text" : "password"}
                />
                <div>
                  <ButtonGeneric
                    funtion={sendNewPass}
                    bgButton={colors.darkBlue}
                    text={"Restablecer contraseña"}
                  />
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center"></div>
                  <div className="text-sm">
                    <Link
                      to={"/cuenta"}
                      className={`font-medium capitalize text-[${colors.darkBlue}] hover:text-[${colors.darkBlue}]`}
                    >
                      {textNewPass.volver}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
      )}
      </div>
      <div
        className={`hidden bg-[url("../public/banner.jpg")] border-[${colors.darkBlue}] border-l-4 bg-cover bg-center bg-no-repeat lg:block relative w-0 flex-1`}
      >
      </div> 
    </div>
    <Modal
      string={check ? "check" : "error"}
      message={message}
      active={activeModal}
      setActive={setActiveModal}
      to={"/cuenta"}
    >
      <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <div className="flex  flex-col gap-2 ">
          <button
            type="button"
            onClick={(e) => {closetModal()
                             (check ? window.location.href='/cuenta' : closetModal())}}
            className={` ${check ? "bg-green-500" : "bg-red-500"
              } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
          >
            Cerrar
          </button>
        </div>
      </div>
    </Modal>
  </>
);
};
export default NewPassword;
